<ion-accordion value="{{ state?.facetId }}">
  <ion-item slot="header" class="facet-header" lines="none">
    {{ state?.displayName }}
  </ion-item>
  <div slot="content" class="facet-value-list">
    <div class="search-bar-container">
      <app-search-bar-facet
        [controller]="controller"
        (showSearchFacetEmitter)="setShowSearchFacet($event)"
        (searchSelectFacetEmitter)="setCurrentFacetId($event)"
      ></app-search-bar-facet>
    </div>

    <div
      class="facet-value-container"
      *ngIf="!showSearchFacet && state?.facetSearch?.values.length === 0"
    >
      <ion-item
        class="facet-selection-container"
        *ngFor="
          let value of state.values;
          let i = index;
          last as isLast;
          trackBy: trackFacetValueId
        "
        [class.first]="i === 0"
        [class.last]="
          isLast && (state?.canShowMoreValues || state?.canShowLessValues)
        "
      >
        <ion-checkbox
          labelPlacement="start"
          justify="space-between"
          class="facet-selection"
          mode="ios"
          [checked]="value.state === 'selected'"
          (ionChange)="handleCheckboxSelection(controller, value)"
        >
          <span class="facet-value-text">
            {{ value?.value | acronymTitleCase | truncateWithEllipsis: 40 }}
          </span>
          <ion-badge mode="ios">
            {{ value?.numberOfResults }}
          </ion-badge>
        </ion-checkbox>
      </ion-item>
      <ng-container
        *ngTemplateOutlet="facetViewButton; context: { facet: controller }"
      ></ng-container>
    </div>
  </div>
</ion-accordion>

<ng-template #facetViewButton let-facet="facet">
  <ion-button
    class="facet-view-button"
    *ngIf="facet.state?.canShowMoreValues"
    (click)="showMoreFacetValues(facet)"
    fill="clear"
  >
    <ion-text>
      {{ 'i18n.search.searchFlyout.viewMore' | translate }}
    </ion-text>
    <ion-icon
      name="chevron-down-outline"
      class="facet-value-icon"
      slot="end"
    ></ion-icon>
  </ion-button>

  <ion-button
    class="facet-view-button"
    *ngIf="facet.state?.canShowLessValues && !facet.state?.canShowMoreValues"
    (click)="showLessFacetValues(facet)"
    fill="clear"
  >
    <ion-text>
      {{ 'i18n.search.searchFlyout.viewLess' | translate }}
    </ion-text>
    <ion-icon name="chevron-up" class="facet-value-icon" slot="end"></ion-icon>
  </ion-button>
</ng-template>
